import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App, { cookieConsentGiven } from './App';
import './index.css';
import { AuthProvider } from './components/auth/AuthProvider';
import { ThemeProvider } from './theme/ThemeContext';
import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: false,
  integrations: [],
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
});

posthog.init(import.meta.env.VITE_POSTHOG_PUBLIC_KEY, {
  api_host: import.meta.env.VITE_POSTHOG_PUBLIC_HOST,
  persistence: cookieConsentGiven() === 'true' ? 'localStorage+cookie' : 'memory',
});

ReactDOM.createRoot(document.getElementById('root')!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>,
);
